import * as jwt from "jsonwebtoken";
const ChangeUrlToken = (url) => {
  const urlTokenValue = jwt.sign(
    {
      url,
    },
    process.env.SECRET_CODE,
    {
      expiresIn: "1d",
    }
  );

  if (typeof window !== "undefined") {
    window.localStorage.setItem("urlToken", urlTokenValue);
  }
};

export default ChangeUrlToken;
